import { cloneDeep } from "lodash-es";
import { designToolMixin } from "../../../../lib/helpers";
const __script_base__ = {
  name: 'FormAutoEditorDesignTool',
  mixins: [designToolMixin],
  computed: {
    path() {
      return this.getCompInstance().path;
    },
    currentLayout() {
      var _this$getCompInstance;
      return (_this$getCompInstance = this.getCompInstance()) === null || _this$getCompInstance === void 0 ? void 0 : _this$getCompInstance.currentLayout;
    }
  },
  methods: {
    eject() {
      this.replaceCompWith({
        ...this.designer.activeComp,
        ...cloneDeep(this.currentLayout)
      });
      this.uc.notifyPageletsChange(0);
    },
    openDataPathSelector() {
      this.designer.openDataPathSelector({
        place: this.$el,
        width: Math.min(500, this.$el.offsetWidth)
      }).then(async dataPath => {
        if (!dataPath) return;
        await this.designer.setBinding(this.compPath, '数据源', dataPath);
        this.designer.compPath = this.compPath;
      });
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return !_vm.path ? _c('div', {
    staticClass: "ucd-fullCoverDesignTool",
    on: {
      "mouseenter": _vm.openDataPathSelector,
      "click": _vm.openDataPathSelector
    }
  }, [_c('div', {
    staticClass: "ucd-fullCoverDesignTool-content"
  }, [_vm._v("\n    请选择要绑定的字段\n  ")])]) : _c('div', {
    staticClass: "ucd-fullCoverDesignTool",
    on: {
      "dblclick": _vm.eject
    }
  }, [_c('div', {
    staticClass: "ucd-fullCoverDesignTool-content"
  }, [_vm._v("\n    这是一个组，双击可转换为普通表单\n  ")])]);
};
var staticRenderFns = [];
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/FormAutoEditor/DesignTool.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);